<template>
  <vx-card
    class="p-0 overflow-hidden">
    <youtube
      :fitParent="true"
      :ref="video"
      :video-id="video"
      :player-vars="playerVars"
      @playing="playing"
      @ended="ended"
      @paused="paused">

    </youtube>
  </vx-card>
</template>

<script>
export default {
  props: {
    video: {
      type: String
    },
    playChanged: {
      type: Function
    },
    index: {
      type: Number
    }
  },
  name: 'VideoContentPages',
  data () {
    return {
      playerVars: {
        autoplay: 0,
        loop: 1,
        muted: 1,
        volume: 0.5,
        controls: 1
      },
      isPlaying: false
    }
  },
  mounted () {
  },
  watch: {
    isPlaying () {
      this.playChanged(this.isPlaying, this.index)
    }
  },
  methods: {
    playing () {
      this.isPlaying = true
    },
    ended () {
      this.$refs[this.video].player.playVideo()
    },
    paused () {
      this.isPlaying = false
    }
  }
}
</script>
